<!-- <Switch on:change={(e)=>console.log(e.detail)} /> -->
<script>
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    export let checked = false;
    export let disabled = false;
    export let checkedText = ''
    export let uncheckedText = ''
    let txt = ''
    const clsName = "sui-switch";
    //点击事件
    function handleClick() {
        checked = !checked;
        dispatch('change',{
                checked: checked,
        })
    }
</script>

<div class={clsName} part={clsName} class:disabled>
    <label
        part={`${clsName}-label`}
        class={`${clsName}-label`}
        for={`${clsName}-1`}
    >
        <slot />
    </label>
    <div
        on:click={handleClick}
        class={`${clsName}-btn`}
        class:checked
        part={`${clsName}-btn`}
        role="switch"
        aria-checked={checked}
        tabindex="0"
        id={`${clsName}-1`}
    >
        <div class="track">
            {#if checkedText !== '' && uncheckedText !== ''}
                 <span>{checked ? checkedText : uncheckedText}</span>
            {/if}
        </div>
        <div class="thumb" />
    </div>
</div>

<style lang="less">
    @import "./switch.less";
</style>